<script setup lang="ts">
defineProps({
  slices: {
    type: Array,
    required: true,
  },
})

interface SliceData {
  __typename?: string
  Settings?: {
    SliceWidth?: string
    BackgroundColor?: string
  }
  [key: string]: unknown
}

const getSliceComponent = (slice: SliceData) => {
  switch (slice?.__typename?.replace('ComponentSlices', '')) {
    case 'ActionsAndEvents':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/ActionsAndEvents.vue`))
    case 'BannerFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/BannerFeed.vue`))
    case 'BlogFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/BlogFeed.vue`))
    case 'Buttons':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Buttons.vue`))
    case 'CategoryFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/CategoryFeed.vue`))
    case 'Cookiebot':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Cookiebot.vue`))
    case 'Faq':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Faq.vue`))
    case 'Embed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Embed.vue`))
    case 'Hero':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Hero.vue`))
    case 'Icons':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Icons.vue`))
    case 'Marquee':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Marquee.vue`))
    case 'MediaFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/MediaFeed.vue`))
    case 'PageFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/PageFeed.vue`))
    case 'ReviewRelationFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/ReviewRelationFeed.vue`))
    case 'ProductsCollectionFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/ProductsCollectionFeed.vue`))
    case 'ProductsFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/ProductsFeed.vue`))
    case 'RichtextFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/RichtextFeed.vue`))
    case 'RichtextWithMedia':
    case 'RichtextWithImage':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/RichtextWithMedia.vue`))
    case 'RichtextWithLook':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/RichtextWithLook.vue`))
    case 'RichtextWithProduct':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/RichtextWithProduct.vue`))
    case 'KiyohReviews':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/KiyohReviews.vue`))
    case 'SaldoChecker':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/SaldoChecker.vue`))
    case 'Spacer':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Spacer.vue`))
    case 'SpotlerProductSlider':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/SpotlerProductSlider.vue`))
    case 'StoreLocator':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/StoreLocator.vue`))
    case 'StoreData':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/StoreData.vue`))
    case 'ShopTheLook':
    case 'ShopTheLookFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/ShopTheLookFeed.vue`))
    case 'Table':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Table.vue`))
    case 'VideoEmbedFeed':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/VideoEmbedFeed.vue`))
    case 'Usp':
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Usp.vue`))
    default:
      return defineAsyncComponent(() => import(`~layers/app/components/Slices/Unknown.vue`))
  }
}
</script>

<template>
  <div
    v-memo="slices"
    class="content-types"
  >
    <component
      :is="getSliceComponent(slice)"
      v-for="(slice, index) in slices"
      :key="index"
      :slice="slice"
      :index="index"
      :slices="slices"
    />

    <!--  -->
  </div>
</template>

<style>
@import url("~layers/app/components/Strapi/Slices.css");
</style>
